<template>
  <Teleport to="#dialog">
    <transition appear name="fade">
      <div id="advanced-search" class="advanced-wrap" v-if="visible">
        <div class="advanced-content">
          <div class="advanced-data">
            <!-- 時間 -->
            <div class="advanced-data-item">
              <div class="advanced-title">
                <p>
                  <span class="icon"></span>
                  時間
                </p>
                <div class="line"></div>
              </div>
              <div class="d-flex-wrap w-100 advanced-button">
                <cus-button
                  v-for="(item, index) in dateRangeBtns"
                  :key="index"
                  :text="item.label"
                  :width="25"
                  :selected="search.date_type === item.value ? true : false"
                  @click="handleClick('date_type', item.value)"
                ></cus-button>
                <!-- 自訂 -->
                <div class="date-range-button" @click="handleOpenDateRange($event)">
                  <div
                    data-action="edit"
                    tabindex="-1"
                    :class="[
                      'date-range',
                      'date-range-size-large',
                      search.date_type === 6 ? 'date-range-selected' : '',
                    ]"
                  >
                    <p data-action="edit">
                      {{ search.date_range.text ? search.date_range.text : '自訂' }}
                    </p>
                    <div v-if="!search.date_range" class="action-icon">
                      <i data-action="edit" class="bi bi-clock"></i>
                    </div>
                    <div v-else class="action-icon">
                      <i
                        data-action="delete"
                        class="bi bi-x-circle"
                        @click="
                          search.date_range = '';
                          search.date_type = search.date_type === 6 ? 1 : search.date_type;
                        "
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 單據 -->
            <div class="advanced-data-item">
              <div class="advanced-title">
                <p>
                  <span class="icon"></span>
                  單據
                </p>
              </div>
              <div class="attesting-wrap advanced-button">
                <cus-radio
                  :radioList="attestingBtns"
                  v-model:selectValue="selectAttesting"
                  style="padding-right: 35px"
                ></cus-radio>
                <div class="attesting-button" @click="handleOpenAttesting($event)">
                  <div
                    :class="['attesting', search[selectAttesting] ? 'attesting-selected' : '']"
                    data-action="edit"
                    tabindex="-1"
                  >
                    <p data-action="edit">
                      號碼{{
                        selectAttesting && selectAttesting === 'invoice_no'
                          ? '：' + search.invoice_no
                          : '：' + search.serial_no
                      }}
                    </p>
                    <div v-if="!search[selectAttesting]" class="action-icon">
                      <i data-action="edit" class="bi bi-pencil"></i>
                    </div>
                    <div v-else class="action-icon">
                      <i data-action="delete" class="bi bi-x-circle" @click="search[selectAttesting] = ''"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 來源 -->
            <div class="advanced-data-item">
              <div class="advanced-title">
                <p>
                  <span class="icon"></span>
                  來源
                </p>
                <div class="line"></div>
              </div>
              <div class="d-flex-wrap w-100 advanced-button">
                <cus-button
                  v-for="(item, index) in sourceBtns"
                  :key="index"
                  :text="item.label"
                  :width="25"
                  :selected="search.source === item.value ? true : false"
                  @click="handleClick('source', item.value)"
                ></cus-button>
              </div>
            </div>
            <!-- 類型 -->
            <div class="advanced-data-item">
              <div class="advanced-title">
                <p>
                  <span class="icon"></span>
                  類型
                </p>
              </div>
              <div class="d-flex-wrap w-100 advanced-button">
                <cus-button
                  v-for="(item, index) in takeAwayBtns"
                  :key="index"
                  :text="item.label"
                  :width="25"
                  :selected="search.take_away_method === item.value ? true : false"
                  @click="handleClick('take_away_method', item.value)"
                ></cus-button>
              </div>
            </div>
            <!-- 資訊 -->
            <div class="advanced-data-item">
              <div class="advanced-title">
                <p>
                  <span class="icon"></span>
                  資訊
                </p>
                <div class="line"></div>
              </div>
              <div class="input-wrap advanced-button">
                <cus-input
                  v-model:value="search.order_user_name"
                  placeholder="姓名"
                  cusClass="advanced-input"
                ></cus-input>
                <cus-input
                  v-model:value="search.order_user_tel"
                  placeholder="電話"
                  cusClass="advanced-input"
                ></cus-input>
                <cus-input
                  v-model:value="search.member_card_no"
                  placeholder="會員編號"
                  cusClass="advanced-input"
                ></cus-input>
                <cus-input
                  v-model:value="search.order_user_address"
                  placeholder="地址"
                  cusClass="advanced-input"
                ></cus-input>
              </div>
            </div>
          </div>
          <div class="advanced-footer">
            <cus-button text="取消" :width="50" color="white" style="padding-left: 0" @click="close"></cus-button>
            <cus-button
              text="搜尋"
              :width="50"
              color="blue"
              style="padding-right: 0"
              @click="handleSearch"
            ></cus-button>
          </div>
        </div>
      </div>
    </transition>
  </Teleport>

  <!-- 彈窗 -->
  <component :is="dialogTemplate"></component>
</template>
<script>
import { inject, ref, defineAsyncComponent } from 'vue';
import { useDialog } from '@/utils/dialog';
import { getDateRangeButton, getOrderButton, getAttestingButton } from '@/utils/define';
import { useGetters } from '@/utils/mapStore';
export default {
  name: 'advanced-search',
  components: {
    DateRangePicker: defineAsyncComponent(() => import('@/components/orderDialog/DateRangePicker.vue')),
    NumberLimitInput: defineAsyncComponent(() => import('@/components/orderDialog/NumberLimitInput.vue')),
  },
  setup() {
    const visible = inject('inner_dialogVisible', false);
    const close = inject('inner_close');
    const submit = inject('inner_submit');
    //按鈕清單
    const { sourceBtns, takeAwayBtns } = getOrderButton();
    const dateRangeBtns = getDateRangeButton();
    const attestingBtns = getAttestingButton();
    //設定參數與初始值
    const search = ref(null);
    const selectAttesting = ref('invoice_no');
    const getSearchCondition = useGetters('manageOrder', ['getSearchCondition']);
    if (visible.value) {
      search.value = JSON.parse(JSON.stringify(getSearchCondition.value));
      if (search.value.serial_no) selectAttesting.value = 'serial_no';
      else selectAttesting.value = 'invoice_no';
    }

    //點擊
    const handleClick = (type, val) => {
      //時間必選其他選填
      if (type == 'date_type') search.value[type] = val;
      else {
        if (search.value[type] === val) search.value[type] = '';
        else search.value[type] = val;
      }
    };

    //使用彈窗
    const { dialogTemplate, openHeaderDialog, closeDialog } = useDialog();

    //自訂時間
    const handleOpenDateRange = (e) => {
      if (e.target.getAttribute('data-action') === 'edit') openHeaderDialog('dateRangePicker');
    };
    const handleDateRangePicker = (val) => {
      const text =
        val.start.slice(0, 4) +
        '/' +
        val.start.slice(4, 6) +
        '/' +
        val.start.slice(6, 8) +
        ' - ' +
        val.end.slice(0, 4) +
        '/' +
        val.end.slice(4, 6) +
        '/' +
        val.end.slice(6, 8);
      search.value.date_range = { ...val, text };
      search.value.date_type = 6;
      closeDialog();
    };

    //發票號碼或訂單序號
    //切換清空
    const clearAttesting = () => {
      if (selectAttesting.value === 'invoice_no') search.value.serial_no = '';
      else search.value.invoice_no = '';
    };
    const handleOpenAttesting = (e) => {
      if (e.target.getAttribute('data-action') !== 'edit') return;
      if (selectAttesting.value === 'invoice_no') openHeaderDialog('inputInvoice');
      else openHeaderDialog('inputSerialNo');
    };
    const handleInputAttesting = (val) => {
      search.value[selectAttesting.value] = val;
      clearAttesting();
      closeDialog();
    };

    //搜尋送出
    const handleSearch = async () => {
      clearAttesting();
      submit(search.value);
    };

    return {
      visible,
      close,
      sourceBtns,
      takeAwayBtns,
      dateRangeBtns,
      attestingBtns,
      selectAttesting,
      search,
      handleClick,
      dialogTemplate,
      handleOpenDateRange,
      handleDateRangePicker,
      handleOpenAttesting,
      handleInputAttesting,
      handleSearch,
    };
  },
};
</script>
<style lang="scss" scoped>
$title-wrap: 15%;
.advanced {
  &-wrap {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: $color-mask;
    @include flex-center-center;
    z-index: 900;
  }
  &-content {
    width: 780px;
    // height: 600px;
    display: grid;
    grid-template-rows: auto 80px;
    @include white-bg;
  }
  &-data {
    padding: 20px 20px 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  &-data-item {
    display: flex;
    align-items: center;
    margin: 12px 0;
  }
  &-title {
    width: $title-wrap;
    color: $color-blue;
    font-size: 2rem;
    @include icon-line;
  }
  &-button {
    width: calc(100% - $title-wrap);
  }
  &-footer {
    padding: 10px 20px;
    display: flex;
  }
}

.input-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 8px;
  padding: 0 4px;
}
:deep(.advanced-input) {
  margin: 0;
  height: $button-min-height;
}
.date-range-button {
  width: 75%;
  @include base-button-wrap;
  .date-range {
    position: relative;
    @include button-set($color-gray-70, $color-gray-3, $color-gray-10);
    &:active {
      @include button-set($color-lightBlue, $color-gray-3, $color-lightBlue);
    }
    @include base-button;
  }
}

.attesting-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  .attesting-button {
    width: 100%;
    @include base-button-wrap;
    cursor: pointer;
    .attesting {
      position: relative;
      @include input-basic;
      margin: 0;
      height: $button-min-height;
      transition: 0.2s;
      &-selected {
        @include button-set(#fff, $color-green, $color-green);
        &:active {
          @include button-set(#fff, $color-green, $color-green);
        }
      }
    }
  }
}
</style>
